<template>
  <div class="dropdown-calendar-type-2">
    <div class="box" :class="{ 'box-disable': mode == false }">
      <span class="box-title">{{ tempBoxTitle }}</span>
      <span class="title" aria-readonly="true">{{ tempTitle }}</span>
      <div class="over-button-box" @click.stop="show" v-if="mode == true"></div>
      <div class="dropdown-box">
        <div class="month-box">
          <div class="previous" @click.stop="previousMonth">
            <input type="button" />
          </div>
          <div class="month">
            <span>{{ selectedMonth }}</span>
          </div>
          <div class="next" @click.stop="nextMonth">
            <input type="button" />
          </div>
        </div>
        <div class="week-box">
          <div class="week" v-for="(week, index) in weeks" :key="index">
            <div class="text">
              <span>{{ week }}</span>
            </div>
          </div>
        </div>
        <div class="day-box">
          <div
            class="day"
            v-for="(day, index) in startDays"
            :key="index"
            @click="setting(day)"
            :class="{ active: tempIndex === day }"
          >
            <div v-if="convertDate(day)"></div>
            <div v-else class="non-active">{{ day === 0 ? '' : day }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from '../../store/mutation-types'
export default {
  name: 'dropdown-calendar-type-2',
  props: {
    boxTitle: {
      default: 'DATE',
      type: String
    },
    title: {
      default: 'Any date',
      type: String
    },
    value: {
      default: '',
      type: String
    },
    mode: {
      default: false,
      type: Boolean
    },
    propDisableDays: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      calendarType2Id: 'cal2' + new Date().getTime().toString(),
      tempTitle: '',
      tempBoxTitle: '',
      tempIndex: null,
      weeks: ['Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat', 'Sun'],
      currentDate: new Date(),
      startDate: '',
      selectedMonth: '',
      startDays: [],
      monthToCharacters: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      nowDate: new Date()
    }
  },
  created() {
    // console.log('input date: ', this.index)
    this.tempBoxTitle = this.boxTitle
    this.selectedMonth =
      this.monthToCharacters[this.currentDate.getMonth()] +
      ' ' +
      this.currentDate.getFullYear()
    this.tempTitle = this.title
    this.tempBoxTitle = this.boxTitle
    this.changeMonth()
  },
  mounted() {
    if (this.value !== '') {
      const indexDate = this.value.split('-')
      const year = parseInt(indexDate[2], 10)
      const month = parseInt(indexDate[1], 10) - 1
      const day = parseInt(indexDate[0], 10)
      // console.log('split :', year, month, day)
      this.currentDate = new Date(year, month, day)
      // console.log('current date:', this.currentDate)
      this.setCalendarTitle()
      this.setting(day)
    } else {
      // this.startDate = new Date(this.currentDate)
      this.startDate = this.currentDate
    }
  },
  methods: {
    convertDate(day) {
      // console.log(this.propDisableDays)
      const compareDate = new Date(this.currentDate).setDate(day)
      const convertDate = `${this.currentDate.getFullYear()}-${this.currentDate.getMonth() +
        1}-${day}`
      // console.log('compareDate:', convertDate)
      const holiday = this.propDisableDays.indexOf(convertDate)
      // console.log('holiday', holiday)
      if (this.nowDate.getTime() > compareDate || holiday > 0) {
        return false
      } else {
        // 예약이 가능한 날짜와, 작가의 홀리데이가 반영되어야 한다.
        // 만약 그날짜가 예약이 다 차지 않으면, 예약이 가능해야 하는가..?

        return true
      }
    },
    /**
     * Click the button to display the corresponding child elements.
     * @param event
     */
    show(event) {
      const el = event.target
      const elChild = el.nextElementSibling // Binding child element.
      // console.log(el.parentElement)
      el.parentElement.className += ' active'
      if (elChild.className === 'dropdown-box') {
        this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear')
        elChild.className += ' active'
      } else {
        elChild.className = 'dropdown-box'
      }
    },
    setting(day) {
      // console.log('setting:', day)
      if (day > 0) {
        this.tempIndex = day
        const date =
          day +
          '-' +
          (this.currentDate.getMonth() + 1) +
          '-' +
          this.currentDate.getFullYear()
        // console.log('settting date:', date)
        // console.log('settting selectedMonth:', this.selectedMonth)

        // this.tempTitle = day + '/' + (this.currentDate.getMonth() + 1)
        //     + '/' + this.currentDate.getFullYear()
        this.tempTitle = day + ' ' + this.selectedMonth
        // console.log('title:', this.tempTitle)
        // console.log('push parents: ', date)
        this.$emit('input', date)
      }
    },
    changeMonth() {
      const tempStartDate = new Date(this.currentDate.getTime())
      this.startDays = []
      tempStartDate.setDate(1)
      if (tempStartDate.getDay() === 0) {
        this.startDays = new Array(6)
        this.startDays.push(1)
      } else {
        this.startDays = new Array(tempStartDate.getDay() - 1)
        this.startDays.push(1)
      }
      for (let i = 2; i < 32; i++) {
        tempStartDate.setDate(i)
        if (this.currentDate.getMonth() === tempStartDate.getMonth()) {
          this.startDays.push(tempStartDate.getDate())
        }
      }
    },
    previousMonth() {
      this.currentDate.setMonth(this.currentDate.getMonth() - 1)
      this.setCalendarTitle()
    },
    nextMonth() {
      this.currentDate.setMonth(this.currentDate.getMonth() + 1)
      this.setCalendarTitle()
    },
    setCalendarTitle() {
      this.selectedMonth =
        this.monthToCharacters[this.currentDate.getMonth()] +
        ' ' +
        this.currentDate.getFullYear()
      this.changeMonth()
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown-calendar-type-2 {
  // Actions to prevent other stylesheets from affecting.
  position: relative;
  display: inline;
  float: left;
  width: 100%;
  /*background-color: rgb(245, 245, 245);*/
  .box-disable {
    &:hover {
      background-color: transparent !important;
      color: #000 !important;
    }
    cursor: auto !important;
    background-image: none !important;
  }
  .box {
    &:hover {
      background-color: rgb(145, 145, 145);
      color: #fff;
    }
    position: relative;
    height: 80px;
    width: inherit;
    background-image: url('../../assets/images/down-arrow.svg');
    background-position: 90% 70%;
    background-repeat: no-repeat;

    .box-title {
      position: absolute;
      top: 15px;
      left: 20px;
      font-weight: 600;
    }

    .title {
      position: absolute;
      top: 43px;
      left: 20px;
      font-weight: 300;
    }

    .over-button-box {
      cursor: pointer;
      position: inherit;
      width: inherit;
      height: inherit;
    }
    //noinspection ALL
    .dropdown-box {
      overflow: hidden;
      height: 0;
      z-index: -1;
      position: absolute;
      left: -1px;
      background-color: rgba(255, 255, 255, 1);
      z-index: 9999;
      color: #000;
      opacity: 0;
      visibility: hidden;
      padding: 10px 0;
      border: 1px solid #dbdbdb;
      width: 100%;
      position: relative;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;

      .month-box {
        background-color: white;
        position: relative;
        margin: 15px 0 0 0;
        display: flex;
        flex-wrap: nowrap;
        .previous {
          margin: 0 0 0 21px;
          cursor: pointer;
          input {
            width: 40px;
            height: 40px;
            background: url('../../assets/images/modal/previous_arrow.svg')
              no-repeat;
            background-position: 0px -1px;
            background-size: 40px;
            border: 0 solid transparent;
            outline: none;
          }
        }

        .next {
          margin: 0 21px 0 0;
          cursor: pointer;

          input {
            width: 40px;
            height: 40px;
            background: url('../../assets/images/modal/next_arrow.svg')
              no-repeat;
            background-position: 0px -1px;
            background-size: 40px;
            border: 0 solid transparent;
            outline: none;
          }
        }

        .month {
          flex: auto;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #000000;

          span {
            line-height: 40px;
          }
        }
      }

      .week-box {
        position: relative;
        display: flex;
        margin: 12px 22px auto 22px;
        font-family: Poppins;
        font-size: 12px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }

      .week {
        flex: auto;
        width: 39px;
        text-align: center;
      }

      .day-box {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        margin: 10px 21px;

        .day {
          width: 44px;
          height: 44px;
          line-height: 38px;
          text-align: center;
          border: 1px solid #e7e7e7;
          margin: 0 0 -1px -1px;
          font-family: Poppins;
          font-size: 12px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          color: #000000;
          cursor: pointer;
          &:hover {
            background-color: #0fb564;
            color: #fff;
          }
        }

        .non-active {
          width: 44px;
          height: 44px;
          line-height: 38px;
          text-align: center;
          border: 1px solid #e7e7e7;
          margin: 0 0 -1px -1px;
          font-family: Poppins;
          font-size: 12px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          color: #000000;
          background-color: #eeeeee;
        }

        .active {
          background-color: #0fb564;
          color: #fff;
        }
      }
    }

    //noinspection ALL
    .active {
      height: 387px;
      z-index: 1000px;
      opacity: 1;
      visibility: visible;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;
    }
  }

  .active {
    background-color: rgb(245, 245, 245);
  }
}
</style>
